import { Checkbox, FormControlLabel, Box } from "@mui/material";
import React from "react";

const checkBoxStyle = { borderRadius: "6px", padding: "0 5px" };
const formControlLabeStyle = { marginBottom: 0, marginRight: 0, marginLeft: 0 };

const SingleSearchRadioGroup = ({ selectedValue, onChange, options }) => {
  return (
    <Box sx={{ marginBottom: "15px", display: "flex", gap: "3rem" }}>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          sx={formControlLabeStyle}
          control={
            <Checkbox
              className="custom-checkbox"
              onChange={() => onChange(option.value)}
              checked={selectedValue === option.value}
              sx={checkBoxStyle}
            />
          }
          label={<span style={{ fontSize: "12px" }}>{option.label}</span>}
        />
      ))}
    </Box>
  );
};

export default SingleSearchRadioGroup;
